<template>
<div :class="light?'light':'dark'" @mouseover="lighting()">
</div>    
</template>
<script>
import math from './mixins/math'
export default {
    mounted: function(){
        this.setLightInterval();
    },
    beforeDestroy: function(){
        clearInterval(this.lightInterval);
    },
    mixins:[math],
    methods:{
        lighting: function(){
            this.light = !this.light;
        },
        setLightInterval: function(){
        this.lightInterval= setInterval(()=>{this.lighting()},this.randomRange(5000,10000));
        }
    },
    data(){
        return{
            light: false,
            lightInterval: null
        }
    }
}
</script>
<style scoped>
.dark{
    background-color: black;
    margin: 5%;
    height: 10px;
    width: 10px;
    display: inline-block;
}
.light{
    background-color: white;
    margin: 5%;
    height: 10px;
    width: 10px;
    display: inline-block;
}
</style>